<template>
  <a class="notifications--bell">
    <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="-49 0 482 482.34787" width="25px" class=""><g><path d="m374.113281 348.804688c-42.183593-24.484376-73.011719-64.617188-85.785156-111.6875l-20.800781-77.769532c-15.359375-57.714844-66.664063-98.585937-126.351563-100.65625l-7.785156-29.046875c-5.71875-21.339843-27.652344-34-48.992187-28.28125-21.332032 5.71875-33.992188 27.648438-28.277344 48.984375l7.773437 29.03125c-50.554687 31.71875-74.523437 92.691406-59.101562 150.34375l20.800781 77.769532c4.171875 15.550781 6.285156 31.585937 6.285156 47.6875-.007812 32.253906-8.476562 63.9375-24.558594 91.894531-4.550781 7.636719-3.941406 17.289062 1.535157 24.289062 4.125 5.425781 10.546875 8.613281 17.359375 8.617188 1.921875-.003907 3.835937-.253907 5.6875-.753907l115.019531-30.808593c8.832031 20.53125 29.007813 33.859375 51.359375 33.929687 16.003906.023438 31.25-6.808594 41.878906-18.773437 10.628906-11.960938 15.625-27.90625 13.71875-43.792969l115.023438-30.808594c9.625-2.585937 16.277344-11.351562 16.179687-21.3125.019531-7.804687-4.175781-15.015625-10.96875-18.855468zm-300.144531-320.808594c4.289062-7.429688 12.21875-12.003906 20.800781-12 10.875-.03125 20.402344 7.273437 23.199219 17.785156l6.757812 25.253906c-.757812.066406-1.503906.214844-2.261718.296875-2.519532.253907-5.019532.578125-7.503906.96875-1.320313.207031-2.640626.421875-3.953126.671875-2.769531.53125-5.507812 1.136719-8.214843 1.808594-.601563.152344-1.207031.238281-1.800781.398438-.59375.160156-.96875.320312-1.457032.457031-3.054687.839843-6.066406 1.789062-9.03125 2.839843-.800781.277344-1.550781.566407-2.328125.855469-3.085937 1.152344-6.125 2.410157-9.113281 3.777344-.230469.101563-.476562.183594-.710938.292969l-6.75-25.199219c-1.679687-6.140625-.828124-12.699219 2.367188-18.207031zm164.261719 396c1.113281 18.953125-11.253907 36.078125-29.597657 40.984375-18.34375 4.898437-37.605468-3.753907-46.128906-20.71875zm126.457031-50.457032-336.960938 90.242188c-2.304687.648438-4.773437-.199219-6.199218-2.128906-1.5-1.882813-1.660156-4.503906-.398438-6.550782 17.507813-30.394531 26.730469-64.847656 26.75-99.921874.003906-17.503907-2.292968-34.929688-6.839844-51.832032l-20.800781-77.761718c-14.152343-52.804688 9.144531-108.507813 56.683594-135.511719l.140625-.0625c6.71875-3.6875 13.777344-6.71875 21.074219-9.054688 2.304687-.761719 4.535156-1.671875 6.894531-2.289062 8.082031-2.140625 16.363281-3.441407 24.714844-3.886719 1.765625-.097656 3.535156-.203125 5.300781-.21875h1.234375c54.277344.011719 101.769531 36.507812 115.757812 88.953125l20.800782 77.777344c13.902344 51.160156 47.421875 94.773437 93.28125 121.375 1.839844.984375 2.980468 2.90625 2.960937 4.992187.089844 2.742188-1.734375 5.183594-4.394531 5.871094zm0 0" data-original="#000000" class="active-path" data-old_color="##81818" fill="#818181"/></g></svg>
    <span class="badge" v-if="newalerts.length > 0">{{ (newalerts.length > 9) ? '*' : newalerts.length }}</span>
    <ul class="dpm wider">
      <li class="head">
        Notifications
      </li>
      <li>
        <notification-component v-for="(alert,index) in allAlerts"  :key="alert.id" :alert="alert" v-on:read="markRead"></notification-component>
        <a class="center" v-if="Object.keys(alerts).length === 0">
          You currently don't have any notifications. 🎉🎊
        </a>
      </li>
      <li class="pt-2">
        <router-link :to="{name: 'all-inbox'}" class="center pt-3 pb-3" href="/dashboard/inbox" style="background:#EFEFEF"> See All Notifications.. </router-link>
      </li>
    </ul>
  </a>
</template>

<script>
import NotificationComponent from './Notification';

export default {
  name: 'notifications',
  components: {
    NotificationComponent,
  },
  data() {
    return {
      alerts: {},
      notifs: {}
    };
  },
  computed: {
    newalerts() {
      return (typeof this.alerts === 'object') ? Object.values(this.alerts).filter(a => !a.read) : this.alerts;
    },
    allAlerts() {
        return Object.values(this.alerts).reverse().splice(0,5)
    }
  },
  methods: {
    fetch() {
      this.$http
        .get(`${BASE_API}/v1/tutor/dashboard-notifications`)
        .then(({ data: { data } }) => {
          data.forEach((a) => {
            this.alerts = { ...this.alerts, [a.id]: a };
          });
          this.$auth.user().notifications.forEach((b) => {
            b['to'] = 'https://prepclass.com.ng'
            b['message'] = b.content
            this.alerts = { ...this.alerts, [b.id]: b };
          })
        })
        .catch(e => console.error(e));
    },
    listen() {
      Echo.channel(`tutor-${this.$auth.user().id}-dashboard-alerts`)
        .listen('TutorDashboardNotification', ({ alert }) => {
          this.alerts = { [alert.id]: alert, ...this.alerts };
        });
    },
    markRead(id) {
      this.$set(this.alerts, id, { ...this.alerts[id], read: true });
    },
  },
  mounted() {
    this.listen();
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
.notifications--bell {
  position: relative;
  span.badge {
    position: absolute;
    top: 5px;
    left: calc(50% + 5px);
    background: lighten(#202030, 25%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    color: #ffffff;
    font-size: 9px;
    line-height: 15px;
    font-weight: 400;
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  &:hover > .dpm {
    display: block;
  }
}
.dpm {
  position: absolute;
  top: calc(100% + 7px);
  left: -50%;
  z-index: 1000;
  float: left;
  display: none;
  min-width: 165px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 6px 12px rgba(150, 150, 150, .175);
  background-clip: padding-box;
  transition: all .3s ease-in-out;
  &:after {
    content: "";
    position: absolute;
    display: block;
    width: 37px;
    height: 12px;
    top: -12px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background-image: url(../../../../../assets/dropdown_arrow.png);
    background-size: 100% 100%;
  }
  &.wider{
    max-width: 300px;
    min-width: 300px;
    left: calc(50% - 150px);
  }
  li {max-width: 100%;}
  li.head {
    padding: 5px 15px;
    font-size: 11px;
    font-weight: 400;
    color: #818181;
    border-bottom: 1px solid rgba(0,0,0,.1);
  }
  li>a {
    padding: 5px 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #818181;
    text-decoration: none;
    white-space: nowrap;
    margin: 5px 0;
    &.wrap {
      white-space: normal;
    }
    &.center {
      font-size: 11px;
      justify-content: center;
    }
  }
  li>a:hover {
    background-image: none;
    filter: none;
    background-color: rgba(2, 17, 27, 0.05);
    color: #818181;
  }
  li>a>svg {
    margin-right: 7px;
  }
  li>hr {
    margin: 10px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Dashboard/partials/Notifications/Notifications.vue